import { Fragment } from "react";

// Bold text for a translation placeholder ("${count}" -> <b>12 Açık Görev</b>)
export const bold = (text) => <b key={`b:${text}`}>{text}</b>;

// Bold name with a normal-weight Turkish suffix: boldSuffixed("Burak Taş", dative) -> <b>Burak Taş</b>'a
export const boldSuffixed = (name, suffixFn) => {
  const text = (name || "").trim();
  const suffixed = suffixFn(text);
  return (
    <Fragment key={`s:${suffixed}`}>
      <b>{text}</b>
      {suffixed.slice(text.length)}
    </Fragment>
  );
};
